import React from 'react';
import LandingLayout from '../../../components/Layout/LandingLayout';
import LandingTerms from '../../../components/LandingLegal/LandingTerms';
import messages from '../../../locale/messages';
import getLandingMessage from '../../landing/getLandingMessage';

// import Layout from '../../../components/Layout';
// import Page from '../../../components/Page';
// import fetch from '../../../core/fetch';

// const query = `query getEditStaticPage ($id: Int!) {
//   getEditStaticPage (id: $id) {
//       id
//       pageName
//       content
//       metaTitle
//       metaDescription
//       createdAt
//   }
// }`;

export default async function action({ store }) {
  // const resp = await fetch('/graphql', {
  //   method: 'post',
  //   headers: {
  //     Accept: 'application/json',
  //     'Content-Type': 'application/json',
  //   },
  //   body: JSON.stringify({
  //     query: query,
  //     variables: { id: 4 },
  //   }),
  //   credentials: 'include',
  // });

  // const { data } = await resp.json();

  return {
    title: getLandingMessage(store, messages.newLandingLegalTermsMetaTitle),
    description: getLandingMessage(store, messages.newLandingLegalTermsMetaDescription),
    chunk: 'privacy',
    component: (
      <LandingLayout>
        <LandingTerms />
      </LandingLayout>
    ),
  };
};
